export default __webpack_public_path__ + "static/media/aeropress.330402c8.svg";